import initialState from './initialstate';
import * as types from '../Actions/actiontypes';
import {HttpStatusCodes} from '../../../../util/uiconstants';

export default function statusAssigmentReducer(state = initialState.statusAssignment, action) {
	switch (action.type) {
		case types.HO_CREATE_TASK_ASSIGNMENT: {
			if (action.responseObj.status !== HttpStatusCodes.Ok) return state;

			if (action.silentRefreshData?.isFromTaskDetails) {
				let assignments = _.cloneDeep(state);
				const newTA =
					!_.isEmpty(action.response) && action.response[0]
						? action.response[0]
						: {
								assignedToRoleId: action.meta.api.data.engagementRoleId,
								assignedToUserId: action.meta.api.data.userId,
								assignmentId: action.meta.api.data.assignmentId,
								dueDays: action.meta.api.data.dueDays,
								isCurrent: !assignments.reviewersList.some((item) => !item.isComplete),
								taskAssignmentId: uuidv4()
						  };

				const addedTaskAssignment = {
					assignedToRoleId: newTA.assignedToRoleId,
					assignedToUserId: newTA.assignedToUserId,
					assignmentId: newTA.assignmentId,
					assignmentName: action.silentRefreshData.assignmentName,
					assignmentTypeId: action.silentRefreshData.assignmentTypeId,
					displayFullname: action.silentRefreshData.displayFullname,
					displayOrder: 0,
					dueDate: action.silentRefreshData.dueDate,
					dueDays: newTA.dueDays,
					firstName: action.silentRefreshData.firstName,
					isComplete: false,
					isCurrent: newTA.isCurrent,
					isEngagementRoleAssignment: false,
					isPreparer: false,
					isTaskHandedOffToOutOfBoundUser: false,
					lastName: action.silentRefreshData.lastName,
					modifiedByDate: null,
					modifiedByFirstName: null,
					modifiedByLastName: null,
					modifiedByName: null,
					reviewersList: null,
					taskAssignedToId: 0,
					taskAssignmentId: newTA.taskAssignmentId,
					timephaseDueDate: null,
					userInitials: action.silentRefreshData.userInitials
				};

				assignments.reviewersList.push(addedTaskAssignment);
				assignments = setCurrent(assignments);

				return assignments;
			}
			if (action.silentRefreshData?.isFromBulk) {
				let assignments = _.cloneDeep(state);
				action.responseObj.data.forEach((data) => {
					if (data.assignedToRoleId == null) {
						data.firstName = action.silentRefreshData.summary.firstName;
						data.lastName = action.silentRefreshData.summary.lastName;
					}
					data.assignedtoUserId = data.assignedToUserId;
					data.assignmentStatusId = AssignmentStatusIds.Open;
					data.assignmentTypeId = action.silentRefreshData.summary.assignmentTypeId;
					data.assignmentName = action.silentRefreshData.summary.assignmentName;
				});
				if (assignments == null) {
					return {
						assignmentsCreated: action.responseObj.data
					};
				}

				assignments.assignmentsCreated = action.responseObj.data;
				return assignments;
			}

			return state;
		}
		case types.HO_EDIT_TASK_ASSIGNMENTS: {
			if (action.responseObj.status !== HttpStatusCodes.Ok) return state;

			if (action.isFromTaskDetails) {
				let editAssignment = _.cloneDeep(state);
				editAssignment.reviewersList.forEach((a) => {
					if (a.taskAssignmentId === action.meta.api.data.taskAssignmentId) {
						const edited = action.meta.api.data;
						a.assignedToRoleId = edited.engagementRoleId || edited.toAssignedToRoleId;
						a.assignedToUserId = edited.userId || edited.toAssignedToUserId;
						a.assignmentId = edited.toAssignmentId;
						a.assignmentName = edited.assignmentName;
						a.assignmentTypeId = edited.toAssignmentTypeId;
						a.displayFullname = edited.displayFullname;
						a.dueDate = edited.dueDate;
						a.dueDays = parseInt(edited.dueDays);
						a.createByDate = edited.createByDate;
						a.userInitials = edited.userInitials;
						a.firstName = edited.firstName || '';
						a.lastName = edited.lastName || '';
						a.isComplete = action.response.isComplete;
						a.isCurrent = action.response.isCurrent;
					}
				});

				editAssignment.reviewersList = editAssignment.reviewersList.sort((item1, item2) =>
					item2.dueDays - item1.dueDays !== 0
						? item2.dueDays - item1.dueDays
						: item1.assignmentTypeId - item2.assignmentTypeId !== 0
						? item1.assignmentTypeId - item2.assignmentTypeId
						: new Date(item1.createByDate) - new Date(item2.createByDate)
				);

				return editAssignment;
			}

			return Object.assign({}, state, {
				assignmentsUpdated: true
			});
		}
		default:
			return state;
	}
}
